import { OnboardingCardDetails } from 'src/components/selfService/features/Signup/steps/LineOfCreditStep/LineOfCreditStep.utils';
import { DAYS } from 'src/models/LineOfCreditModelUtils';

export const transitionDuration = 500;
export const defaultLineOfCreditStepStyles = {
  transition: `all ${transitionDuration}ms ease-in`,
  opacity: 0,
};

export const LineOfCreditStepTransitionStyles = {
  entering: {
    opacity: 0,
    height: 0,
  },
  entered: {
    opacity: 1,
    height: 'auto',
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
};

export const defaultDays = new Array(DAYS.length).fill(false);

export const defaultFormValues = {
  creditName: '',
  amount: '',
  budgetLength: '',
  date: '',
  frequency: '',
  days: defaultDays,
};

export const onboardingCardDetails: OnboardingCardDetails[] = [
  {
    imageAltText: 'Meal credit limits',
    imageUrl:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1776895061/corp-management-ui/balance/PiggyBankAndCalculatorIllustration_svg.png',
    primaryText: 'Meal credit limits',
    secondaryText:
      'Decide who can use your credit, how much, and when. Manage meal credits from your account at any time, and you’ll only get charged when people use them.',
  },
  {
    imageAltText: 'It’s meal time!',
    imageUrl:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773311466/corp-management-ui/balance/Grubhub%20Phone%20Illustration_png.png',
    primaryText: 'It’s meal time!',
    secondaryText:
      'Let people know when it’s time to order. The credit will be automatically applied when they place an order using their Grubhub account.',
  },
  {
    imageAltText: 'Real-time payments',
    imageUrl:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1776895146/corp-management-ui/balance/CashIllustration_png.png',
    primaryText: 'Real-time payments',
    secondaryText:
      'Your method of payment will only be charged once someone places an order. Each order will appear as a separate transaction on your account.',
  },
];
